import React from "react";
import { BrowserRouter, Route, Routes, Link, useLocation } from "react-router-dom";
import {
  navBar,
  mainBody,
  about,
  repos,
  leadership,
  stack,
  getInTouch,
  experiences
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import AboutMe from "./components/home/AboutMe";
import Project from "./components/home/Project";
import Stack from "./components/home/Stack";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Leadership from "./components/home/Leadership.jsx";

import Experience from "./components/home/Experience";

const Home = React.forwardRef((props, ref) => {
  return (
    <>
      <MainBody
        title={mainBody.firstName}
        message={mainBody.message}
        avatar={about.show ? about.imageLink : null}
        email={getInTouch.show ? getInTouch.email : null}
        ref={ref}
      />
      {experiences.show && (
        <Experience
          heading={experiences.heading}
          data={experiences.data}
          limit={3}
          viewAllHref="/work"
        />
      )}
      {repos.show && (
        <Project
          heading={repos.heading}
          username={repos.gitHubUsername}
          length={repos.reposLength}
          specfic={repos.specificRepos}
          order={repos.featured}
          viewAllHref="/work"
        />
      )}
      {stack.show && <Stack heading={stack.heading} items={stack.items} />}
    </>
  );
});

const BackLink = () => (
  <Link className="text-link" to="/">
    &larr; Back
  </Link>
);

const AboutPage = () => (
  <div className="page-top-spacing">
    <div className="container pt-4">
      <BackLink />
    </div>
    {about.show && (
      <AboutMe
        heading={about.heading}
        message={about.message}
        resume={about.resume}
      />
    )}
    {stack.show && <Stack heading={stack.heading} items={stack.items} />}
    {leadership.show && (
      <Leadership
        heading={leadership.heading}
        message={leadership.message}
        img={leadership.images}
        imageSize={leadership.imageSize}
      />
    )}
  </div>
);

const WorkPage = () => (
  <div className="page-top-spacing">
    <div className="container pt-4">
      <BackLink />
    </div>
    {experiences.show && (
      <Experience heading={experiences.heading} data={experiences.data} />
    )}
    {repos.show && (
      <Project
        heading={repos.heading}
        username={repos.gitHubUsername}
        length={repos.reposLength}
        specfic={repos.specificRepos}
      />
    )}
  </div>
);

const AnimatedRoutes = ({ titleRef }) => {
  const location = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" exact element={<Home ref={titleRef} />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/work" element={<WorkPage />} />
      </Routes>
    </div>
  );
};

const App = () => {
  const titleRef = React.useRef();

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
      {navBar.show && <Navbar ref={titleRef} />}
      <AnimatedRoutes titleRef={titleRef} />
      <Footer>
        {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )}
      </Footer>
    </BrowserRouter>
  );
};

export default App;
